import css from "./styles.module.scss";
import cn from "classnames";
import playIcon from "assets/icons/play-icon.png";
import { useState, useRef, useEffect, useMemo } from "react";
import { Spinner } from "shared/components/Spinner";
export const VideoPlayer = ({ videoID, autoplay, className }) => {
  const iframeRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [wasPlayed, setWasPlayed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const placeHolderImage = useMemo(() => {
    return `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`;
  }, [videoID]);

  const handlePlayClick = () => {
    iframeRef.current.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: !isPlaying ? "playVideo" : "pauseVideo",
        args: "",
      }),
      "*"
    );

    setWasPlayed(true);
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const initVideo = () => {
      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "playVideo",
          args: "",
        }),
        "*"
      );

      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: "",
        }),
        "*"
      );
    };
    if (!isLoading && !wasPlayed && !autoplay) {
      initVideo();
    }
  }, [isLoading]);

  return (
    <div className={cn(css.videoPlayerWrapper, className)}>
      <div className={css.videoOverlay} onClick={handlePlayClick}>
        {!isPlaying && !autoplay && (
          <div className={css.playIconWrapper}>
            <img src={playIcon} alt="play icon" className={css.icon} />
          </div>
        )}
      </div>
      {!wasPlayed && placeHolderImage && !autoplay && (
        <img
          src={placeHolderImage}
          alt="Video placeholder"
          className={css.backgroundImage}
        />
      )}
      {isLoading && (
        <div className={css.spinnerWrapper}>
          <Spinner type="big" className={css.spinner} />
        </div>
      )}
      <iframe
        className={css.homeVideo}
        src={`https://www.youtube.com/embed/${videoID}?playlist=${videoID}&enablejsapi=1&version=3&playerapiid=ytplayer&autoplay=${
          autoplay ? 1 : 0
        }&controls=0&loop=1&mute=1&disablekb=1&playsinline=1&fs=0&rel=0&showinfo=0&modestbranding=1`}
        ref={iframeRef}
        onLoad={() => setIsLoading(false)}
        referrerPolicy="no-referrer"
      />
    </div>
  );
};
